import React from 'react'
import { useQuery } from 'react-query'
import { getZonesToCover } from '../../../MyApi/zonesToCover'
import DataTable from '../../UI/table/DataTable'
import LoadingSpinner from '../../UI/spinner'

const ZonesToCover = ({id}) => {
  const lang = localStorage.getItem("i18nextLng") || "ar"

  const {data, isLoading} = useQuery(
    ["getZonesToCover", id],
    () => getZonesToCover(lang, id)
  )

  const zones = data?.data?.zones_to_cover || []

  const zonesColumns = [
    { label: "معرف المنطقة", accessor: "zone_id" },
    { label: "اسم المنطقة", accessor: "zone" },
     { label: "الدولة", accessor: "country" },
        { label: "المحافظة", accessor: "governorate" },
    { label: "المدينة", accessor: "city" },
       { label: "عدد السائقين", accessor: "couriers_count" },
        
 
  ];


  return (
    <div>
      <DataTable
        isLoading={isLoading}
        columns={zonesColumns}
        data={zones}
      />
    </div>
  )
}

export default ZonesToCover
